import { t } from 'utils/i18n';

const ERROR_CODE = {
  COURSE_ASK: {
    ID_INVALID: 14204,
    TEACHER_NOT_EXIST: 14205,
    TEACHER_NOT_EXIST_IN_COURSE: 14206,
    TEACHER_ALREADY_ACCEPT: 14207,
    STUDENT_NO_COURSE: 14208,
    CONFLICT_OVER: 14210,
    TIME_OVER: 14211,
    BATCH_COURSE_ACCEPTING: 14213,
    COURSE_ACCEPTING: 10131,
    INVITE_CANCEL: 14214,
  },
};

/**
 * 對外只開放代碼本身，訊息仍由下方的對照表提供。
 *
 * 搶連續課（認領模式）要判斷「這張單是不是已經不存在了」來決定要不要清掉選取，
 * 需要引用代碼常數，不該在各自的 feature 裡重打一次 14207 這種字面值。
 */
export const COURSE_ASK_ERROR_CODE = ERROR_CODE.COURSE_ASK;

export const batchScheduledCourseErrorMessages = {
  [ERROR_CODE.COURSE_ASK.ID_INVALID]: t(
    'courseAsk.failMessage.idInvalid',
    '連續課程id無效',
  ),
  [ERROR_CODE.COURSE_ASK.TEACHER_NOT_EXIST]: t(
    'courseAsk.failMessage.teacherNotExist',
    '此老師不存在',
  ),
  [ERROR_CODE.COURSE_ASK.TEACHER_NOT_EXIST_IN_COURSE]: t(
    'courseAsk.failMessage.teacherNotExistInCourse',
    '此老師不存在於這個連續課程',
  ),
  [ERROR_CODE.COURSE_ASK.TEACHER_ALREADY_ACCEPT]: t(
    'courseAsk.failMessage.teacherAlreadyAccept',
    '已經有老師接受連續排課',
  ),
  [ERROR_CODE.COURSE_ASK.STUDENT_NO_COURSE]: t(
    'courseAsk.failMessage.studentNoCourse',
    '學生無課程可排課',
  ),
  [ERROR_CODE.COURSE_ASK.CONFLICT_OVER]: t(
    'courseAsk.failMessage.conflictOver',
    '衝堂超過三堂',
  ),
  [ERROR_CODE.COURSE_ASK.TIME_OVER]: t(
    'courseAsk.failMessage.timeOver',
    '此邀請已超過48小時',
  ),
  [ERROR_CODE.COURSE_ASK.BATCH_COURSE_ACCEPTING]: t(
    'courseAsk.failMessage.batchCourseAccepting',
    '連續課程處理中',
  ),
  [ERROR_CODE.COURSE_ASK.COURSE_ACCEPTING]: t(
    'courseAsk.failMessage.courseAccepting',
    '一般課程處理中',
  ),
  [ERROR_CODE.COURSE_ASK.INVITE_CANCEL]: t(
    'courseAsk.failMessage.inviteCancel',
    '此邀約已取消',
  ),
};
